// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.resumenMultiple[data-v-2a926fcb]{\n    border-top: 1px solid rgba(161, 161, 161, 0.312);\n}\n", ""]);
// Exports
module.exports = exports;
